"use strict";
var r, e;
function t() {
  return e || (e = 1, r = Object.getOwnPropertyDescriptor), r;
}
export {
  t as __require
};
//# sourceMappingURL=index.es402.js.map
